import React from 'react';
import ApiService from './ApiService';
import { showModal, closeModal } from '../PageLayout/MainModal';
import { Button } from 'react-bootstrap';
import Spinner from '../PageLayout/Spinner';

class ComputeService {
  static confirmDeletion(projectId, computeInstance, confirmPendingCallback, confirmCallback, closeCallback) {
    const renderConfirmModal = (stateLabel) => {
      const title = 'Delete Compute Instance';
      const content = (
        <div>
          <p>
            Do you realy want to delete the compute instance {'"'}{computeInstance.name}{'"'} ?
          </p>
          <Button variant="outline-primary" onClick={() => cancel()}>No</Button>{'\t'}
          <Button variant="primary" onClick={() => confirm()}>Yes{stateLabel}</Button>
        </div>
      );
      showModal(title, content, closeCallback);
    };

    const confirm = () => {
      if (confirmPendingCallback) {
        confirmPendingCallback();
      }
      ApiService.deleteProjectComputeInstance(projectId, computeInstance.name).then(() => {
        confirmCallback();
        closeModal();
      });
      renderConfirmModal(<span> <Spinner /></span>);
    };

    const cancel = () => {
      closeModal();
    };

    renderConfirmModal(null);
  }
}

export default ComputeService;
